import {
  FETCH_SHOP_COLLECTION_REQUEST,
  FETCH_SHOP_COLLECTION_SUCCESS,
  FETCH_SHOP_COLLECTION_FAILURE,
  UPDATE_SHOP_COLLECTION
} from '../../actionTypes/shopCollectionActionTypes'

const initialState = {
  data: {},
  meta: {}
}

const buildRequestState = (oldState, payload) => {
  const { data: oldData = {}, meta: oldMeta = {} } = oldState
  const { partNumber } = payload
  const newState = {
    ...oldState,
    data: {
      ...oldData,
      [partNumber]: {
        ...(oldData[partNumber] || {})
      }
    },
    meta: {
      ...oldMeta,
      [partNumber]: {
        ...oldMeta[partNumber],
        errorDetail: '',
        requestDone: false
      }
    }
  }
  return newState
}

const buildSuccessState = (oldState, payload) => {
  const { data: oldData = {}, meta: oldMeta = {} } = oldState
  const { partNumber, data: payloadData = {}, meta: payloadMeta = {} } = payload
  const newState = {
    ...oldState,
    data: {
      ...oldData,
      [partNumber]: {
        products: [...payloadData]
      }
    },
    meta: {
      ...oldMeta,
      [partNumber]: {
        ...oldMeta[partNumber],
        ...payloadMeta,
        errorDetail: '',
        requestDone: true
      }
    }
  }
  return newState
}

const buildFailureState = (oldState, payload) => {
  const { data: oldData = {}, meta: oldMeta = {} } = oldState
  const { partNumber, errorDetail } = payload
  const newState = {
    ...oldState,
    data: {
      ...oldData,
      [partNumber]: {
        ...(oldData[partNumber] || {})
      }
    },
    meta: {
      ...oldMeta,
      [partNumber]: {
        ...oldMeta[partNumber],
        errorDetail,
        requestDone: true
      }
    }
  }
  return newState
}

const updateShopCollection = (oldState, payload) => {
  const { data: oldData = {} } = oldState
  const { partNumber, data: payloadData = {} } = payload
  const newState = {
    ...oldState,
    data: {
      ...oldData,
      [partNumber]: {
        ...(oldData[partNumber] || {}),
        ...payloadData
      }
    }
  }
  return newState
}

const shopCollectionReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_SHOP_COLLECTION_REQUEST:
      return buildRequestState(state, payload)
    case FETCH_SHOP_COLLECTION_SUCCESS:
      return buildSuccessState(state, payload)
    case FETCH_SHOP_COLLECTION_FAILURE:
      return buildFailureState(state, payload)
    case UPDATE_SHOP_COLLECTION:
      return updateShopCollection(state, payload)
    default:
      return state
  }
}

export { initialState, shopCollectionReducer }
